import(/* webpackMode: "eager" */ "/vercel/path0/app/(routes)/faqs/page.jsx");
